/**
 * The 30 min / 1h / 2h / 4h / Until tomorrow buttons of the global snooze (#94, §19.2).
 *
 * `CadenceQuickPicks`'s sibling, and deliberately its opposite in one way: these are **actions**,
 * not a choice. A snooze has no selected face because it is over the moment it expires, and the
 * surface that shows one prints the server's "Snoozed until …" sentence instead. The labels are the
 * whole vocabulary the client knows; every instant behind them is computed server-side.
 */

import type { WatchSnoozePreset } from '@lw/shared';

/** Label per preset, in the order both surfaces render them. */
export const SNOOZE_PICKS: readonly { preset: WatchSnoozePreset; label: string }[] = [
  { preset: '30m', label: '30 min' },
  { preset: '1h', label: '1h' },
  { preset: '2h', label: '2h' },
  { preset: '4h', label: '4h' },
  { preset: 'tomorrow', label: 'Until tomorrow' },
];

export type SnoozePicksProps = {
  onPick: (preset: WatchSnoozePreset) => void;
  disabled?: boolean;
  /** Names the group for assistive tech, e.g. "Snooze watching". */
  ariaLabel: string;
};

export function SnoozePicks({ onPick, disabled, ariaLabel }: SnoozePicksProps) {
  return (
    <div className="watch-picks" role="group" aria-label={ariaLabel}>
      {SNOOZE_PICKS.map((pick) => (
        <button
          key={pick.preset}
          type="button"
          className="btn-ghost btn-ghost--sm"
          disabled={disabled}
          onClick={() => onPick(pick.preset)}
        >
          {pick.label}
        </button>
      ))}
    </div>
  );
}

export default SnoozePicks;
